import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FabContainer } from 'ionic-angular';


/**
   * Logger Factory
   * @namespace color: name of color
   * @namespace items: list of items to show
   * @namespace isRight: If true, the fab is showed to the right
   * @namespace icon: Is the name of icon to use
   * @namespace gradientVisible: If true, the background gradient is showed 
   * ES:
   * <ute-fab [items]="items" (onClickValueItem)="test($event)" color="primary" icon="add"></ute-fab> 
*/

@Component({
  selector: 'ute-fab',
  templateUrl: 'ute-fab.component.html'
})
export class UteFabComponent implements OnChanges {
  @Input() color: string;
  @Input() items: [any];
  @Input() isRight: boolean;
  @Input() icon: string;
  @Input() disabled: boolean;
  @Input() gradientFromTop: boolean;
  @Output() onClickValueItem = new EventEmitter();

  public gradientVisible = false;
  public isItems = false;
  
  constructor() {}

  ngOnChanges(simpleChange: SimpleChanges){
    if(simpleChange.items && simpleChange.items.currentValue && simpleChange.items.currentValue.length > 0 ){
      this.isItems = true;
    }
    if(simpleChange && simpleChange.disabled){
      this.disabled = simpleChange.disabled.currentValue;
    }
    
  }
  
  showGradient(){
    this.gradientVisible = !this.gradientVisible;
  }

  onSubItemClick(action, fab: FabContainer){
    if (fab !== undefined) {
      fab.close();
    }
    this.gradientVisible = !this.gradientVisible;
    this.onClickValueItem.emit(action);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-fab/ute-fab.component.ts